import type { Maybe } from "graphql/jsutils/Maybe";
import { G_VideoSeasonType } from "~/lib/graphql";

const TAG_TEXT = {
  NEW_AND_EXCLUSIVE: "独占 | 新着",
  NEW: "新着",
  EXCLUSIVE: "独占",
} as const;

type Args = {
  /** 新着作品かどうか */
  isNewArrival: boolean;
  /** 独占作品かどうか */
  isExclusive: boolean;
  /** カスタムタグの中身*/
  customTag?: Maybe<string>;
  /** シーズン種別 */
  seasonType?: G_VideoSeasonType;
};

export const getTagText = (args: Args) => {
  const { customTag, isNewArrival, isExclusive, seasonType } = args;
  if (seasonType === G_VideoSeasonType.Stage || seasonType === G_VideoSeasonType.SpotLive) {
    return customTag ? customTag : null;
  }
  if (customTag) return customTag;
  if (isNewArrival && isExclusive) return TAG_TEXT.NEW_AND_EXCLUSIVE;
  if (isNewArrival) return TAG_TEXT.NEW;
  if (isExclusive) return TAG_TEXT.EXCLUSIVE;
  return null;
};
